import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { Logo } from "./Logo";
import { useI18n } from "../lib/i18n";
import { useTheme } from "../lib/theme";
import { Button } from "./ui/button";
import { Sun, Moon, UserPlus } from "lucide-react";
import { REGISTER_URL } from "../lib/config";

export default function Layout() {
  const { t, lang, setLang } = useI18n();
  const { theme, toggle } = useTheme();

  const navLinkClass = ({ isActive }) =>
    "wc-nav-link" + (isActive ? " wc-nav-link-active" : "");

  return (
    <div className="wc-shell">
      <header className="wc-header" data-testid="app-header">
        <div className="wc-header-inner">
          <NavLink to="/" className="wc-brand" data-testid="nav-brand">
            <Logo size={44} />
            <div className="wc-brand-text">
              <span className="wc-brand-name">WordCripto</span>
              <span className="wc-brand-sub">{t("tagline")}</span>
            </div>
          </NavLink>

          <nav className="wc-nav" aria-label="primary">
            <NavLink to="/" end className={navLinkClass} data-testid="nav-simulator">
              {t("nav_sim")}
            </NavLink>
            <NavLink to="/confronta" className={navLinkClass} data-testid="nav-compare">
              {t("nav_compare")}
            </NavLink>
            <NavLink to="/istruzioni" className={navLinkClass} data-testid="nav-help">
              {t("nav_help")}
            </NavLink>
            <NavLink to="/azienda" className={navLinkClass} data-testid="nav-company">
              {t("nav_company")}
            </NavLink>
          </nav>

          <div className="wc-lang" role="group" aria-label="language">
            <a
              href={REGISTER_URL}
              target="_blank"
              rel="noreferrer"
              className="wc-header-cta"
              data-testid="header-register"
            >
              <UserPlus size={14} /> {lang === "it" ? "Iscriviti" : "Sign up"}
            </a>
            <Button
              variant="ghost"
              size="icon"
              className="wc-theme-btn"
              onClick={toggle}
              aria-label="toggle theme"
              data-testid="theme-toggle"
            >
              {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
            </Button>
            <Button
              variant={lang === "it" ? "default" : "ghost"}
              size="sm"
              className={lang === "it" ? "wc-lang-active" : "wc-lang-btn"}
              onClick={() => setLang("it")}
              data-testid="lang-it"
            >
              {t("lang_it")}
            </Button>
            <Button
              variant={lang === "en" ? "default" : "ghost"}
              size="sm"
              className={lang === "en" ? "wc-lang-active" : "wc-lang-btn"}
              onClick={() => setLang("en")}
              data-testid="lang-en"
            >
              {t("lang_en")}
            </Button>
          </div>
        </div>
      </header>

      <main className="wc-main">
        <Outlet />
      </main>

      <footer className="wc-footer" data-testid="app-footer">
        <div className="wc-footer-inner">
          <span>© 2026 Wordcripto Unipessoal LDA · Company Number 519515471</span>
          <span className="wc-footer-note">{t("footer_disclaimer")}</span>
        </div>
      </footer>
    </div>
  );
}
